import React from 'react';
import { func, string, bool } from 'prop-types';
import { MenuItem, Select } from '@nextiva/next-ui-components';

/**
 * Warning: option.value can not be 0
 * It looks like its being seen as a "falsey"
 * value in the <Select />
 */

export const options = [
  { key: 0, value: 'None', label: 'None' },
  { key: 1, value: 'Owner Only', label: 'Owner Only' },
  { key: 2, value: 'Everything', label: 'Everything' },
];

export const CrudSelect = ({
  onChange,
  value,
  disabled,
  'data-testid': dataTestId,
}) => {
  return (
    <div className="m-crud-menu">
      <Select
        onChange={onChange}
        value={value}
        disabled={disabled}
        data-testid={dataTestId}
      >
        {options.map((opt) => (
          <MenuItem key={opt.key} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

CrudSelect.propTypes = {
  onChange: func.isRequired,
  disabled: bool,
  value: string,
};

CrudSelect.defaultProps = {
  value: 'None',
  disabled: false,
};

export default CrudSelect;
